@let story = data();

<section class="cursor-pointer mb-16" [routerLink]="url()">
  <img
    [src]="story.content.components[0].image?.filename"
    alt="Image"
    class="rounded-t-lg lg:rounded-lg object-cover w-full h-56 sm:h-48"
  />
  <div class="flex flex-col pt-6 rounded-b-lg bg-white lg:bg-transparent">
    <div class="px-6 pb-6 lg:p-0">
      <p class="date pb-2">
        {{ story.content.components[0].date | slice: 0 : 10 }}
      </p>
      @if (story.content.components[0].title; as title) {
        <p class="mainTitle pb-4">
          {{ title | slice: 0 : 100 }}
          @if (story.content.components[0].title.length > 100) {
            <span>...</span>
          }
        </p>
      }
      <p class="mainContent pb-4">
        {{ story.content.components[0].preview }}...
      </p>
      <p class="article">{{ "blog.article" | translate }}</p>
    </div>
  </div>
</section>
